import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { PrimaryButton } from '../button'
import { useHistory } from 'react-router-dom'
import AppsDropdown from './apps-dropdown'
import { CreateProduct, CreateProductVariables } from '../../queries/types/CreateProduct'
import { useMutation, useQuery } from '@apollo/client'
import { createProductQuery, getAllAppsQuery } from '../../queries'
import { AllApps } from '../../queries/types/AllApps'
import { App } from '../../types/global'
import { Field, FormCard, PageHeader, inputClassName } from '../ui'

export function ProductCreate(): JSX.Element {
    const {t} = useTranslation()
    const history = useHistory()
    const [ title, setTitle ] = useState('')
    const [ mmk, setMMK ] = useState('')
    const [ usd, setUSD ] = useState('')
    const [ app, setApp ] = useState<App|null>(null)
    const { data: apps } = useQuery<AllApps>(getAllAppsQuery, {
        fetchPolicy: 'cache-and-network'
    })
    const [ createProduct ] = useMutation<CreateProduct, CreateProductVariables>(createProductQuery)

    function createAndGo() {
        if (title == '' || (mmk == '' && usd == '')) {
            return Promise.reject('fields must be filled')
        }

        if (app == null) {
            return Promise.reject('app must be selected')
        }

        return createProduct({
            variables: {
                appID: app.id,
                title: title,
                MMK: mmk != '' ? Number(mmk) : undefined,
                USD: usd != '' ? Number(usd) : undefined
            }
        }).then(() => {
            history.push('/products')
        })
    }

    return (
        <>
            <PageHeader title={t('products-create.title')} />
            <FormCard>
                <Field label={t('products-create.form.label.app')}>
                    {apps ? <AppsDropdown items={apps.apps} selected={app} onDidSelect={setApp} className='w-full mt-1' /> : null}
                </Field>
                <Field label={t('products-create.form.label.title')}>
                    <input name='title' value={title} onChange={(e) => setTitle(e.target.value)} className={inputClassName} placeholder={t('products-create.form.placeholder.title')} />
                </Field>
                <Field label={t('products-create.form.label.priceMMK')}>
                    <input name='mmk' value={mmk} onChange={(e) => setMMK(e.target.value)} className={inputClassName} placeholder='1000' />
                </Field>
                <Field label={t('products-create.form.label.priceUSD')}>
                    <input name='usd' value={usd} onChange={(e) => setUSD(e.target.value)} className={inputClassName} placeholder='1' />
                </Field>
                <div className='mt-6 flex justify-end'>
                    <PrimaryButton onClick={() => createAndGo()} type='submit'>{t('shared.button.label.submit')}</PrimaryButton>
                </div>
            </FormCard>
        </>)
}
